import PatchOps from '@leverege/api-patch-ops'
import { connect } from 'react-redux'
import Path from '@leverege/path'
import React from 'react'
import PropTypes from 'prop-types'

import { ScriptActions, BreadcrumbActions, UserActions } from '~/actions'
import { ScriptFactory } from '~/editors/script'

import style from './style.css'

const SCRIPT_PATH = 'scriptData/code'

class ScriptCodeScreen extends React.Component {

  constructor( props ) {
    super( props )
    this.state = {
      code : ''
    }
  }

  componentDidMount() {
    this.props.dispatch( ScriptActions.get( this.props.match.params.projectId, this.props.match.params.scriptId ) )
    // let profile
    // try {
    //   profile = JSON.parse( localStorage.getItem( 'profile' ) )
    // } catch ( ex ) {
    //   // sad
    // }
    // console.log( profile )
    // if ( profile ) {
    //   console.log( profile )
    //   this.context.store.dispatch( UserActions.get( profile.id ) )
    // }
  }

  componentWillReceiveProps( next ) {
    const { scripts } = next
    const { params } = next.match
    const scriptId = params.scriptId
    const script = scripts.lookup[scriptId]

    const code = Path( `scripts/lookup/${scriptId}/${SCRIPT_PATH}` ).get( next, '' )
    this.setState( { code } )

    if ( script ) {
      this.props.dispatch( BreadcrumbActions.setBreadcrumbs( 
        [
          { name : 'Scripts', link : `/project/${script.projectId}/script` }, 
          { name : script.name }
        ]
      ) )
    }
  
  }

  onSave = () => {

  }
  
  onScriptChange = ( { target, path, value } ) => {
    const { scripts, dispatch } = this.props
    const { params } = this.props.match

    const scriptId = params.scriptId
    const script = scripts.lookup[scriptId]
    if ( script == null ) {
      return
    }
    if ( path === 'deployedCode' ) {
      dispatch( ScriptActions.deploy( params.projectId, script ) )
    } else if ( path === 'code' ) {
      this.setState( { code : value } )
    } else if ( path === 'save' ) {
      const { params } = this.props.match
      const patchOps = PatchOps().replace( 'code', this.state.code ).ops()

      dispatch( ScriptActions.update( params.projectId, target, patchOps ) )
    } else {
      const { params } = this.props.match
      const patchOps = PatchOps().replace( path, value ).ops()
      dispatch( ScriptActions.update( params.projectId, target, patchOps ) )
    }
  }

  onUserChange = ( { target, path, value } ) => {

    let profile
    try {
      profile = JSON.parse( localStorage.getItem( 'profile' ) )
    } catch ( ex ) {
      // sad
    }

    const patchOps = PatchOps().replace( path, value ).ops()
    this.props.dispatch( UserActions.update( target, patchOps ) ).then( ( data ) => {
      if ( data && profile ) {
        Path( path ).set( profile, value )
        localStorage.setItem( 'profile', JSON.stringify( profile ) )
        this.forceUpdate()
      }
    } )
  }

  render() {
    const { scripts } = this.props
    const { params } = this.props.match
    const { code } = this.state
    let profile
    try {
      profile = JSON.parse( localStorage.getItem( 'profile' ) )
    } catch ( ex ) {
      // sad
    }

    const scriptId = params.scriptId
    const script = scripts.lookup[scriptId]
    if ( script == null ) {
      return null
    }
    const details = ScriptFactory.createCodeEditor( script, {
      onChange : this.onScriptChange,
      onChangeUser : this.onUserChange,
      user : profile,
      scriptPath : 'scriptData/code',
      editedCode : code,
      enableSave : true
    } )
    return <div className={style.editor}>{details}</div>
  }
}

export default connect(
  state => ( {
    scripts : state.scripts,
    // users : state.users
  } )
)( ScriptCodeScreen )
